import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import ViewProps from '../types/ViewProps'
import Typed, { Segment } from './Typed'

export default ({ loading }: ViewProps) => {
	let history = useHistory()
	const [ navigating, setNavigating ] = useState<boolean>(false)
	function handleClick() {
		setNavigating(true)
		setTimeout(() => {
	    history.push("/questions");
		}, 750)
  }

  const header = document.querySelector('#header') as HTMLElement
  if (header && window.innerWidth < 500) {
	  window.scrollTo(0, header.offsetTop)
  }

	return (
		<div className={"quiz-wrapper start" + (navigating ? ' navigating' : '')}>
			<div className="eye-graphic" />
			<div className="quiz-content-wrapper">
				<div className="quiz-content">
					<h1><Typed>What will <Segment delay={1000} duration={600}><strong>you</strong></Segment> create here?</Typed></h1>
					<div onClick={handleClick} className='nav-link'>start</div>
				</div>
			</div>
		</div>
	)
}
